import { EMainRoutes } from 'shared/typings';

export const ROUTES_WITHOUT_BOTTOM_BAR = [
	`/${EMainRoutes.CHANNELS}/${EMainRoutes.CREATE}`,
	`/${EMainRoutes.CHANNELS}/${EMainRoutes.EDIT}`,
	`/${EMainRoutes.POST}/${EMainRoutes.CREATE}`,
	`/${EMainRoutes.POST}/${EMainRoutes.EDIT}`,
];
